import CryptoJS from "crypto-js";

const decryptData = (data: string, secretKey?: string) => {
    const decryptedData = CryptoJS.AES.decrypt(data, secretKey || '')
    var result = decryptedData.toString(CryptoJS.enc.Utf8);
    return result
}
export default decryptData;